module.exports = __webpack_public_path__ + "static/prophetic-prism-mtg_clb-3a386505bfeb51459bd61c6ed1afbc1b.jpg";